export const getWebHeaders = (consumerVersion) => ({
    clientFeature: "player-page",
    clientPage: "Player",
    clientVersion: consumerVersion || "",
    widgetName: "PlayerPageWidget",
    widgetVersion: VERSION,
});
//# sourceMappingURL=getWebHeaders.js.map